import { getResolvedRef as e, mergeSiblingReferences as t } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { buildRequestBody as n, coerceLeafValueToSchemaType as r, getExample as i, getExampleFromBody as a, getExampleFromSchema as o, needsMultipartEncoding as s, resolveLeafSchema as c, serializeFormPropertyWithEncoding as l, serializeMultipartArray as u, serializeMultipartBody as d } from "@scalar/workspace-store/request-example";
import { isXmlMediaType as f } from "@scalar/helpers/http/is-xml-media-type";
import { getExampleValue as p, getExplicitExampleText as m } from "@scalar/workspace-store/helpers/get-example-value";
import { serializeStreamExample as h } from "@scalar/workspace-store/helpers/serialize-stream-example";
import { snapshotSchema as g } from "@scalar/workspace-store/helpers/snapshot-schema";
import { unpackProxyObject as _ } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var v = (e, t, n) => ({
	name: e,
	value: `@${t}`,
	fileName: t,
	...n ? { contentType: n } : {}
}), y = (e) => !!e && "type" in e && e.type === "string" && "format" in e && e.format === "binary", b = (e, t) => typeof e == "string" && e.startsWith("@") && y(t) ? e.slice(1) : void 0, x = (e, t, n, i = !1, a) => {
	let o = [], s = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [d, f] of s) {
		if (f == null) continue;
		let s = n ? void 0 : t?.[d];
		if (i && !n) {
			let t = Array.isArray(e) ? r(f, c(a, [d])) : f, n = u(d, Array.isArray(t) ? t : f, s);
			if (n) {
				for (let e of n) {
					if (e.value instanceof File) {
						o.push(v(e.key, e.value.name, e.contentType ?? e.value.type));
						continue;
					}
					o.push({
						name: e.key,
						value: e.value,
						...e.contentType ? { contentType: e.contentType } : {}
					});
				}
				continue;
			}
		}
		let p = s && (s.style !== void 0 || s.explode !== void 0 || s.allowReserved !== void 0), m = p || !i ? void 0 : s?.contentType, h = i && !n ? b(f, c(a, [d])) : void 0, g = n ? null : l(d, f, s);
		if (g) for (let e of g) o.push({
			name: e.key,
			value: e.value
		});
		else if (f instanceof File) {
			let e = _(f);
			o.push(v(d, e.name, m ?? (i ? e.type : void 0)));
		} else if (h !== void 0) o.push(v(d, h, m));
		else if (m && typeof f == "object") o.push({
			name: d,
			value: JSON.stringify(_(f)),
			contentType: m
		});
		else if (i && !n && !p && typeof f == "object" && !Array.isArray(f)) o.push({
			name: d,
			value: JSON.stringify(_(f)),
			contentType: "application/json"
		});
		else if (Array.isArray(f)) for (let e of f) if (e instanceof File) {
			let t = _(e);
			o.push(v(d, t.name, i ? t.type : void 0));
		} else o.push({
			name: d,
			value: String(e)
		});
		else if (typeof f == "object") {
			let e = x(f, void 0, d);
			for (let t of e) o.push({
				name: `${d}.${t.name}`,
				value: t.value
			});
		} else o.push({
			name: d,
			value: String(f),
			...m ? { contentType: m } : {}
		});
	}
	return o;
}, S = ({ requestBody: r, contentType: c, example: l, openapiVersion: u, requestBodyCompositionSelection: v }) => {
	let y = c || Object.keys(r.content)[0] || "", b = y === "other" ? "" : y, S = (e) => `@${_(e).name || "filename"}`, C = r.content[y]?.encoding, w = r.content[y];
	if (w && s(y, w)) {
		let e = l ?? Object.keys(w.examples ?? {})[0] ?? "default", t = n({
			...r,
			"x-scalar-selected-content-type": { [e]: y }
		}, e, v);
		if (t?.mode === "multipart") {
			let e = d(t.value, t.contentType);
			return {
				mimeType: e.contentType,
				text: e.chunks.map((e) => e instanceof File ? S(e) : e instanceof Blob ? "BINARY" : String(e)).join("")
			};
		}
	}
	let T = y === "multipart/form-data" || y === "application/x-www-form-urlencoded";
	if (f(y)) {
		let e = a(r, y, l ?? "", v, u);
		return e ? {
			mimeType: b,
			text: e.value
		} : void 0;
	}
	let E = p(i(r, l, c)), D = m(E, y);
	if (D !== void 0) return {
		mimeType: b,
		text: D
	};
	let O = E?.value;
	if (O !== void 0) {
		let n = typeof O == "object" && O ? _(O) : O;
		return T && typeof n == "object" && n ? {
			mimeType: b,
			params: x(n, C, void 0, y === "multipart/form-data", e(r.content[y]?.schema, t))
		} : n instanceof File ? {
			mimeType: b,
			text: S(n)
		} : {
			mimeType: b,
			text: typeof n == "string" ? n : h(n, y, !1) ?? JSON.stringify(n)
		};
	}
	let k = r.content[y], A = e(k?.schema ?? k?.itemSchema);
	if (A !== void 0) {
		let e = o(g(A), {
			compositionSelection: v,
			mode: "write",
			binaryAsFile: y === "multipart/form-data"
		}, { schemaPath: ["requestBody"] });
		if (e !== void 0) return T && typeof e == "object" && e ? {
			mimeType: b,
			params: x(e, C, void 0, y === "multipart/form-data", A)
		} : {
			mimeType: b,
			text: h(e, y, k?.schema === void 0) ?? (typeof e == "string" ? e : JSON.stringify(e))
		};
	}
};
//#endregion
export { S as processBody };

//# sourceMappingURL=process-body.js.map